import {gql} from 'apollo-angular';


export const emergencyContactsGql = gql`
query ReloadEmergencyContactsQuery($participantId: [Int!]) {
  Participant(participantId: $participantId) {
    participantId
    event {
      eventId
    }
    emergencyContacts {
      emergencyContactId
      emergencyContactPhones {
        phoneType {
          cmgmtPhoneTypeId
        }
        cmgmtEmergencyContactPhoneId
        areaCode
        phoneNumber
        primaryFl
      }
      emergencyContactType {
        emergencyContactTypeId,
        name,
        description
      }
      constituentRelationshipType {
        constituentRelationshipTypeId,
        name,
        description
      }
      contactFirstName
      contactLastName
    }
  }
}
`;